/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2636__part-139
 */

"use strict"

import * as /* [auto-meaningful-name] */Src_shared_ui_components_index from /* 13 */"../../../../src/shared/ui/components/index"
import /* [auto-meaningful-name] */React from /* 0 */"react"
import * as /* [auto-meaningful-name] */Module_934 from /* 934 */"./934"
import /* [auto-meaningful-name] */Module_9341 from /* 934 */"./934"
var _C = function (e) {
  var /* [auto-meaningful-name] */e$formConfig = e.formConfig
  return React.createElement("div", {
    className: Module_9341.warnBox
  }, React.createElement("div", {
    className: Module_9341.content
  }, React.createElement("span", null, React.createElement("div", {
    className: Module_9341.icon
  }, React.createElement(Src_shared_ui_components_index.j, {
    type: "icon-trumpet"
  })), "将在2023年12月31日停止服务，建议使用新的", React.createElement("a", {
    target: "_blank",
    className: Module_9341.link,
    href: e$formConfig.url
  }, e$formConfig.label), "控件")))
}
export { _C }
